import { useLayoutEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { SpinLoading } from 'antd-mobile';
import { useAuth } from '../context/AuthContext';
import { readWsTokenFromSearchParams, resolveWsTokenForWsRoute } from '../utils/wsToken';

/**
 * WhatsApp 登录/注册专用路由：
 * - URL 带 wstoken 时先清本地长期登录，避免误进上一会员（如 40808）
 * - 不再使用 RedirectIfAuthenticated，有 wstoken 时必须走 yc_login_ws / yc_register_ws
 */
export default function WhatsAppWsRoute({ children }) {
  const { initialized, isAuthenticated, logoutLocalOnly } = useAuth();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const urlToken = readWsTokenFromSearchParams(searchParams);
  const wsToken = resolveWsTokenForWsRoute(searchParams);
  const handoffDone = useRef(false);

  useLayoutEffect(() => {
    if (!urlToken || handoffDone.current) {
      return;
    }
    handoffDone.current = true;
    logoutLocalOnly();
  }, [urlToken, logoutLocalOnly]);

  if (!initialized) {
    return (
      <div className="loading-screen">
        <SpinLoading color="primary" />
        <span>Loading...</span>
      </div>
    );
  }

  if (isAuthenticated && urlToken) {
    return (
      <div className="loading-screen">
        <SpinLoading color="primary" />
        <span>Preparing WhatsApp sign-in…</span>
      </div>
    );
  }

  if (isAuthenticated && !wsToken) {
    return <Navigate to="/" replace />;
  }

  return children;
}
